import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { ThyroidIcon } from "../ThyroidIcon";
import { LabResultsSection } from "./LabResultsSection";
import { CLINIC_COLORS, BTN_GRADIENT } from "./theme";

const CARD_STYLE = {
  background: "#ffffff",
  borderRadius: "0.75rem",
  boxShadow: "0 4px 20px rgba(0,101,141,0.06)",
  border: "1px solid rgba(189,200,209,0.15)",
};

export function LabResultsStep({
  testValues,
  handleInputChange,
  isBloodPanelRequired,
  isBloodPanelComplete,
  hasAnyValue,
  onBack,
  onContinue,
  error,
  isDoctorView = false,
}) {
  const { t } = useTranslation();
  const disabled = !hasAnyValue || !isBloodPanelComplete();

  return (
    <div className="animate-fade-in space-y-6">
      {/* Main lab card */}
      <div className="p-8" style={CARD_STYLE} data-testid="thyroid-form-card">
        <div className="flex items-center gap-3 mb-6">
          <div
            className="w-10 h-10 rounded-xl flex items-center justify-center"
            style={{ background: "rgba(198,231,255,0.3)" }}
          >
            <ThyroidIcon className="w-5 h-5" style={{ color: CLINIC_COLORS.primary }} />
          </div>
          <div>
            <h2 className="text-lg font-semibold" style={{ color: CLINIC_COLORS.ink }}>
              {t("dashboard.labResults")}
            </h2>
            <p className="text-sm" style={{ color: CLINIC_COLORS.subtle }}>
              {t("dashboard.labResultsInputDesc")}
            </p>
          </div>
        </div>

        <LabResultsSection
          testValues={testValues}
          handleInputChange={handleInputChange}
          isBloodPanelRequired={isBloodPanelRequired}
          error={error}
        />
      </div>

      {/* Footer actions */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-4">
        <button
          type="button"
          data-testid="labs-back-btn"
          onClick={onBack}
          className="order-2 md:order-1 px-8 py-3 font-semibold rounded-full transition-all inline-flex items-center gap-2"
          style={{ color: CLINIC_COLORS.primary, background: "transparent" }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#ebeef3")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
        >
          <ArrowLeft className="w-4 h-4" />
          {t("dashboard.backToHealthHistory")}
        </button>
        <button
          type="button"
          data-testid="continue-to-ultrasound-btn"
          onClick={onContinue}
          disabled={disabled}
          className="order-1 md:order-2 w-full md:w-auto px-12 py-4 text-white font-bold rounded-full shadow-lg transition-all hover:scale-[1.02] active:scale-95 inline-flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
          style={{ background: BTN_GRADIENT, boxShadow: "0 8px 20px rgba(0,101,141,0.25)" }}
        >
          {t("common.continue") || "Continue"}
          <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
